import { GET_TAGS_SUCCESS } from './tag.types';

const initialState = {
    tagList: [],
    tagListByModule: {},
};

export const tagReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Tags */
        case GET_TAGS_SUCCESS:
            return {
                ...state,
                tagList: action.payload,
                tagListByModule: action.module ? { ...state.tagListByModule, [action.module]: action.payload } : state.tagListByModule,
            };
        /** End */

        default:
            return state;
    }
};
